import React from 'react';
import icon from '../../../../../../assets/icons/charts/zoomAndFilter/icon_sliced_chart.svg';
import SVG from "react-inlinesvg";

const IconSlicedChart = () => (

    <SVG src={icon} height={40} style = {{ marginTop: 10}} />

);
export default IconSlicedChart;